/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useMemo } from 'react';
import {
  Box,
  Typography,
  Paper,
  Collapse,
  Grid,
  Chip,
} from '@mui/material';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';

const Step5View: React.FC = () => {
  const { formulario } = useFormularioSecretariaMunicipalAgriculturaStore();
  const [gruposAbertos, setGruposAbertos] = useState<Set<string>>(new Set(['infraestrutura']));

  const grupos = useMemo(() => [
    {
      id: 'infraestrutura',
      titulo: 'Infraestrutura Predial e Instalações',
      items: [
        { label: 'Prédio Próprio', key: 'possui_predio_proprio', qtdKey: 'quantidade_predio_proprio' },
        { label: 'Prédio Alugado', key: 'possui_predio_alugado', qtdKey: 'quantidade_predio_alugado' },
        { label: 'Prédio Cedido de Outro Órgão', key: 'possui_predio_cedido', qtdKey: 'quantidade_predio_cedido' },
        { label: 'Galpão / Armazém de Insumos', key: 'possui_galpao', qtdKey: 'quantidade_galpao' },
        { label: 'Viveiro Municipal / Estufa', key: 'viveiro_producao_mudas', qtdKey: 'quantidade_viveiro_producao_mudas' },
        { label: 'Auditório / Sala de Reunião', key: 'possui_auditorio', qtdKey: 'quantidade_auditorio' },
        { label: 'Cozinha Piloto / Refeitório', key: 'possui_cozinha_piloto', qtdKey: 'quantidade_cozinha_piloto' },
      ],
    },
    {
      id: 'tecnologia',
      titulo: 'Tecnologia e Engenharia',
      items: [
        { label: 'Computador de Mesa (Desktop)', key: 'possui_computador', qtdKey: 'quantidade_computador' },
        { label: 'Notebook', key: 'possui_notebook', qtdKey: 'quantidade_notebook' },
        { label: 'Impressora / Multifuncional', key: 'possui_impressora', qtdKey: 'quantidade_impressora' },
        { label: 'Tablet', key: 'possui_tablet', qtdKey: 'quantidade_tablet' },
        { label: 'Receptor GPS de Navegação (Portátil)', key: 'possui_receptor_gps_navegacao', qtdKey: 'quantidade_receptor_gps_navegacao' },
        { label: 'Receptor GPS Geodésico (Precisão/Topografia)', key: 'possui_receptor_gps_geodesico', qtdKey: 'quantidade_receptor_gps_geodesico' },
        { label: 'Equipamento de Coleta / Análise de Solo', key: 'possui_equipamento_coleta_solo', qtdKey: 'quantidade_equipamento_coleta_solo' },
        { label: 'Drone para Mapeamento', key: 'possui_drone', qtdKey: 'quantidade_drone' },
      ],
    },
    {
      id: 'frota_leve',
      titulo: 'Frota Leve e Administrativa',
      items: [
        { label: 'Veículo de Passeio (Hatch/Sedan)', key: 'possui_veiculo_popular', qtdKey: 'quantidade_veiculo_popular' },
        { label: 'Caminhonete (Pick-up leve)', key: 'possui_veiculo_caminhonete', qtdKey: 'quantidade_veiculo_caminhonete' },
        { label: 'Caminhonete Traçada 4x4', key: 'possui_caminhonete_tracada', qtdKey: 'quantidade_caminhonete_tracada' },
        { label: 'SUV', key: 'possui_veiculo_suv', qtdKey: 'quantidade_veiculo_suv' },
        { label: 'Motocicleta', key: 'possui_veiculo_motocicleta', qtdKey: 'quantidade_veiculo_motocicleta' },
      ],
    },
    {
      id: 'frota_pesada',
      titulo: 'Frota Pesada e Caminhões',
      items: [
        { label: 'Caminhão Caçamba', key: 'possui_caminhao_cacamba', qtdKey: 'quantidade_caminhao_cacamba' },
        { label: 'Caminhão Baú', key: 'possui_caminhao_bau_sem_refrigeracao', qtdKey: 'quantidade_caminhao_bau_sem_refrigeracao' },
        { label: 'Caminhão Baú Refrigerado', key: 'possui_caminhao_bau_refrigerado', qtdKey: 'quantidade_caminhao_bau_refrigerado' },
        { label: 'Caminhão Pipa', key: 'possui_caminhao_pipa', qtdKey: 'quantidade_caminhao_pipa' },
        { label: 'Caminhão Tanque Isotérmico', key: 'possui_caminhao_com_tanque_isotermico', qtdKey: 'quantidade_caminhao_com_tanque_isotermico' },
        { label: 'Caminhão Prancha', key: 'possui_caminhao_prancha', qtdKey: 'quantidade_caminhao_prancha' },
      ],
    },
    {
      id: 'maquinario',
      titulo: 'Maquinário Agrícola e Pesado',
      items: [
        { label: 'Microtrator', key: 'possui_trator_14cv', qtdKey: 'quantidade_trator_14cv' },
        { label: 'Trator Agrícola (Linha leve/média)', key: 'possui_trator_50cv', qtdKey: 'quantidade_trator_50cv' },
        { label: 'Trator Agrícola (Linha pesada)', key: 'possui_trator_75cv', qtdKey: 'quantidade_trator_75cv' },
        { label: 'Retroescavadeira', key: 'retroescavadeira', qtdKey: 'quantidade_retroescavadeira' },
        { label: 'Escavadeira Hidráulica', key: 'escavadeira_hidraulica', qtdKey: 'quantidade_escavadeira_hidraulica' },
        { label: 'Pá Carregadeira', key: 'pa_carregadeira', qtdKey: 'quantidade_pa_carregadeira' },
        { label: 'Motoniveladora', key: 'possui_motoniveladora', qtdKey: 'quantidade_motoniveladora' },
        { label: 'Grade Aradora / Niveladora', key: 'possui_grade_aradora', qtdKey: 'quantidade_grade_aradora' },
        { label: 'Plantadeira / Semeadeira', key: 'possui_plantadeira', qtdKey: 'quantidade_plantadeira' },
        { label: 'Distribuidor de Calcário / Adubo', key: 'possui_distribuidor_calcario', qtdKey: 'quantidade_distribuidor_calcario' },
      ],
    },
  ], []);

  if (!formulario) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <Typography>Carregando informações...</Typography>
      </Box>
    );
  }

  const toggleGrupo = (grupoId: string) => {
    const novosAbertos = new Set(gruposAbertos);
    if (novosAbertos.has(grupoId)) {
      novosAbertos.delete(grupoId);
    } else {
      novosAbertos.add(grupoId);
    }
    setGruposAbertos(novosAbertos);
  };

  return (
    <Paper elevation={1} sx={{ p: 0, mt: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 500,
            color: 'text.primary',
            p: 2,
            fontSize: '18px',
          }}
        >
          Estrutura
        </Typography>

        {/* Render Grouped Sections */}
        {grupos.map((grupo) => (
          <Box key={grupo.id}>
            {/* Group Header - Collapsible */}
            <Box
              onClick={() => toggleGrupo(grupo.id)}
              sx={{
                px: 3,
                py: 2,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#f5f5f5',
                borderTop: '1px solid #e0e0e0',
                '&:hover': {
                  backgroundColor: '#e8e8e8',
                },
                transition: 'all 0.2s ease',
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 600,
                  color: '#333',
                  flex: 1,
                }}
              >
                {grupo.titulo}
              </Typography>
              {gruposAbertos.has(grupo.id) ? (
                <KeyboardArrowUpOutlined sx={{ color: '#666' }} />
              ) : (
                <KeyboardArrowDownOutlined sx={{ color: '#666' }} />
              )}
            </Box>

            {/* Group Content - Collapsible */}
            <Collapse in={gruposAbertos.has(grupo.id)} timeout="auto" unmountOnExit>
              <Box sx={{ p: 3, borderTop: '1px solid #e0e0e0' }}>
                <Grid container spacing={2}>
                  {grupo.items.map((item) => (
                    <Grid item xs={12} sm={6} key={item.key}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '12px',
                          backgroundColor: '#fafafa',
                          borderRadius: '4px',
                          border: '1px solid #e0e0e0',
                        }}
                      >
                        <Typography sx={{ fontSize: '14px', flex: 1 }}>
                          {item.label}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, ml: 2 }}>
                          <Chip
                            label={(formulario as any)?.[item.key] === true ? 'Sim' : 'Não'}
                            color={(formulario as any)?.[item.key] === true ? 'success' : 'error'}
                            size="small"
                            variant="outlined"
                          />
                          <Typography
                            sx={{
                              fontSize: '14px',
                              fontWeight: 600,
                              minWidth: '50px',
                              textAlign: 'center',
                            }}
                          >
                            {(formulario as any)?.[item.key] === true
                              ? (formulario as any)?.[item.qtdKey] || '0'
                              : '0'}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Collapse>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default Step5View;
